import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { useEffect } from 'react'
import { langList } from '../../../factories/Utils'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedMenu } from '../../../store/MenuReducer'
import { requiredRule } from '../../../utils/rules'
import AttachmentEditor from '../../AttachmentEditor'
import { Localizable } from '../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedMenu())

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item)
    }
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Localizable.Input
        name="label"
        rules={[requiredRule()]}
        label={'Name'}
        max={20}
      />
      {langList.map((lang) => (
        <AttachmentEditor
          dragger={{ fileTypes: ['pdf'] }}
          label={`${lang.flag} ${lang.name} replace attachment`}
          formItem={{ name: [lang.code, 'file'], rules: [] }}
        />
      ))}
    </Form>
  )
}

export default Update
